import store from "datastore/store";

import { setSectionName, setSectionTags } from "actions/sections";
import { observeDoc } from "api";

import observeTables from "./observeTables";

export default function observeSection(businessUid, sectionUid) {
  const docPath = `tables/${businessUid}/sections/${sectionUid}`;
  let unsubscribers = [];
  const docUnsubscribe = observeDoc(docPath, (section) => {
    if (section) {
      store.dispatch(setSectionName(section.uid, section.name));
      store.dispatch(setSectionTags(section.uid, section.tags ?? []));
      const unsub = observeTables(businessUid, section.uid);
      unsubscribers.push(unsub);
    }
  });
  unsubscribers.push(docUnsubscribe);
  return () => unsubscribers.forEach((el) => el?.());
}
